import { translate } from "app/filters/i18nFilter";
import { EXTENSION_LINK } from "app/pages/sales-intelligence/constants/common";

const MAX_MAILTO_URL_LENGTH = 2000;
const MAILTO_FALLBACK_DELAY_MS = 500;

const buildEmailBody = (): string => {
    return [
        translate("si.management.extension.governance.email.body.greeting"),
        "",
        translate("si.management.extension.governance.email.body.intro"),
        "",
        `${translate("si.management.extension.governance.email.body.install_link_label")} ${EXTENSION_LINK}`,
        "",
        translate("si.management.extension.governance.email.body.instructions_intro"),
        translate("si.management.extension.governance.email.body.step1"),
        translate("si.management.extension.governance.email.body.step2"),
        translate("si.management.extension.governance.email.body.step3"),
        "",
        translate("si.management.extension.governance.email.body.questions"),
        "",
        translate("si.management.extension.governance.email.body.thanks"),
    ].join("\n");
};

const getEmailParts = (): { subject: string; body: string } => ({
    subject: translate("si.management.extension.governance.email.subject"),
    body: buildEmailBody(),
});

const buildGmailComposeUrl = (to: string, subject: string, body: string): string => {
    const params = new URLSearchParams({ view: "cm", fs: "1", to, su: subject, body });
    return `https://mail.google.com/mail/?${params.toString()}`;
};

export const buildMailtoUrl = (to: string): string => {
    const { subject, body } = getEmailParts();
    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const openSetupGuideMailto = (to: string): void => {
    const mailtoUrl = buildMailtoUrl(to);
    const newWindow = window.open(mailtoUrl, "_blank");

    if (!newWindow) {
        const { subject, body } = getEmailParts();
        window.open(buildGmailComposeUrl(to, subject, body), "_blank");
        return;
    }

    const { subject, body } = getEmailParts();
    const gmailUrl = buildGmailComposeUrl(to, subject, body);

    setTimeout(() => {
        try {
            if (!newWindow.location.href || newWindow.location.href === "about:blank") {
                newWindow.location.href = gmailUrl;
            }
        } catch {
            // Cross-origin means the mailto handler navigated successfully
        }
    }, MAILTO_FALLBACK_DELAY_MS);
};

export type OpenSetupGuideEmailResult = {
    emailsCopiedToClipboard: boolean;
};

export const openSetupGuideEmail = async (emails: string[]): Promise<OpenSetupGuideEmailResult> => {
    const to = emails.join(",");
    const fullUrl = buildMailtoUrl(to);

    if (fullUrl.length <= MAX_MAILTO_URL_LENGTH) {
        openSetupGuideMailto(to);
        return { emailsCopiedToClipboard: false };
    }

    await navigator.clipboard.writeText(emails.join("; "));
    openSetupGuideMailto("");
    return { emailsCopiedToClipboard: true };
};
